import ClearRecordedAudio from "./ClearRecordedAudio"
import StopSpeechRecognition from "./StopSpeechRecognition"

const CancelRecording = ({
  isRecording,
  mediaRecorderRef,
  setIsRecording,
  setRecordedAudioFile,
  recordedAudioUrl,
  setRecordedAudioUrl,
  setRecordingTime,
  recognitionRef,
  setIsDictating,
  setInterimTranscript,
  dictationBaseRef,
  dictatedFinalRef,
  setNewComment,
}) => {
  if (isRecording && mediaRecorderRef.current) {
    try { mediaRecorderRef.current.stop() } catch {}
    setIsRecording(false)
  }

  ClearRecordedAudio({
    setRecordedAudioFile,
    recordedAudioUrl,
    setRecordedAudioUrl,
    setRecordingTime,
  })

  StopSpeechRecognition({
    recognitionRef,
    setIsDictating,
    setInterimTranscript,
    dictationBaseRef,
    dictatedFinalRef,
    setNewComment,
  })
}

export default CancelRecording
